module.exports = __webpack_public_path__ + "static/index/img/baikal-800.9b3d683f.jpg";